import React, { PureComponent } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    suppressDeprecationWarnings: true,
  },
});

class QuizQuestion extends PureComponent {

  constructor() {
    super();
    this.state = {
      value: undefined,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.reset && this.props.reset) {
      this.setState({ value: undefined });
      this.props.updateScore(this.props.num - 1, undefined);
    }
  }

  doReset() {
    this.setState({ value: undefined });
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
    this.props.updateScore(this.props.num - 1, parseInt(event.target.value, 0));
  }

  renderRadioButtons() {
    return this.props.options.map((option, i) => {
      return (<FormControlLabel key={ i } value={ String(i) } label={ this.props.options[i] } className="quizQuestion-radio" control={<Radio />} />);
    });
  }

  render() {
    const classQuestion = this.props.num % 2 === 1 ? 'quizQuestion' : 'quizQuestion quizQuestion--beige';
    return (
      <div className={ classQuestion }>
        <div className={ this.props.showError && this.state.value === undefined ? 'error' : '' }>
          <span className="quizQuestion-num">{ this.props.num }. </span>
          <span className="quizQuestion-title" dangerouslySetInnerHTML={{ __html: this.props.question }}></span>
        </div>
        <div>
        <MuiThemeProvider theme={theme}>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="options"
              name="options"
              className="quizQuestion-radioGroup"
              value={ this.state.value }
              onChange={ this.handleChange }
            >
            { this.renderRadioButtons() }
            </RadioGroup>
            </FormControl>
          </MuiThemeProvider>
        </div>
      </div>
    );
  }

}

export default QuizQuestion;



// WEBPACK FOOTER //
// ./src/components/quizQuestion.js